module.exports = {
    "dashboard": "계기반",
    "myAccounts": "내 크레딧",
    "internationalTransfer": "국제 송금",
    "fundingType": "카드 및 계정",
    "deposit": "구매 크레딧",
    "withdraw": "빼내다",
    "invoice": "송장",
    "requestMoney": "금액 요청",
    "recipients": "받는 사람",
    "developers": "개발자",
    "myProfile": "내 프로필",
    "logout": "로그 아웃",
    "qucikBooks": "퀵북",
    "profileDetails": "프로필 세부정보",
    "password": "비밀번호",
    "users": "사용자",
    "qbDownloads": "QB 다운로드",
    "transfer": "옮기다",
    "allTransactions": "내 거래",
    "recurringTrans": "반복 거래",
    "firstName": "이름",
    "lastName": "성",
    "emailAddress": "이메일 주소",
    "userRole": "사용자 역할",
    "settings": "설정",
    "oldPass": "기존 비밀번호",
    "newPass": "새 비밀번호",
    "confirmPass": "비밀번호 확인",
    "passwordRequirements": "암호 요구 사항",
    "reqOne": "최소 8자",
    "reqTwo": "적어도 하나의 소문자",
    "reqThree": "적어도 하나의 대문자",
    "reqFour": "적어도 하나의의 숫자",
    "reqFive": "적어도 하나의 특수 문자",
    "reqSix": "적어도 하나의 특수 문자",
    "reqSeven": "공백 없음",
    "saveChanges": "변경 사항을 저장하다",
    "onlyIntAccounts": "해외 계정만",
    "availableBalance": "사용 가능한 잔액",
    "currentBalance": "현재의 잔액",
    "lastUpdatedDate": "마지막 업데이트 날짜",
    "channel": "채널",
    "webhook": "웹훅",
    "recipientName": "받는 사람 이름",
    "aCHAccountNumber": "ACH 계좌 번호",
    "wireAccountNumber": "송금 계좌 번호",
    "aPIKey": "API 키",
    "clientName": "고객 이름",
    "createdBy": "작성자",
    "transactionID": "트랜잭션 ID",
    "sourceType": "소스 유형",
    "accountReference": "계정 참조",
    "routingReference": "라우팅 참조",
    "expiryDate": "만료일",
    "recipientEmail": "이메일 수령인",
    "creationDate": "생산 일",
    "startDate": "시작일",
    "reference": "참조",
    "transactionType": "거래 유형",
    "name": "이름",
    "phone": "핸드폰",
    "role": "역할",
    "complete": "완벽한",
    "failure": "실패",
    "returns": "반납하다",
    "count": "세다",
    "accounts": "계정",
    "noAccounts": "계정 없음",
    "transactionsType": "거래 유형",
    "mostRecentTransactions": "가장 최근 거래",
    "export": "내보내다",
    "transactionHistory": "거래 내역",
    "transactionReference": "트랜잭션 참조",
    "parentReference": "상위 참조",
    "paymentReference": "결제 참조",
    "amount": "양",
    "invoiceNumber": "송장 번호",
    "feeAmount": "요금",
    "reversalFee": "반환 수수료",
    "taxAmount": "세액",
    "exciseTax": "소비세",
    "salesTax": "판매세",
    "registrationFee": "등록비",
    "serviceFee": "서비스 요금",
    "conversionRate": "전환율",
    "oFACMatch": "OFAC 경기",
    "type": "유형",
    "recurringReference": "반복 참조",
    "status": "상태",
    "created": "만들어진",
    "account": "계정",
    "receiver": "수화기",
    "description": "설명",
    "paymentType": "지불 유형",
    "from": "에서",
    "sendVia": "통해 보내기",
    "recipientEmailAddress": "받는 사람 이메일 주소",
    "recipientPhoneNumber": "받는 사람 전화번호",
    "recipientAccountNumber": "수취인 계좌 번호",
    "confirmAccountNumber": "계좌번호 확인",
    "to": "에게",
    "currency": "화폐",
    "direction": "방향",
    "paymentDate": "결제일",
    "service": "서비스",
    "frequency": "빈도",
    "endDate": "종료 날짜",
    "numberofTransfers": "전송 횟수",
    "internalDescription": "내부 설명",
    "accountNumber": "계좌 번호",
    "pc_accountNumber": "銀行口座番号",
    "fileName": "파일 이름",
    "recipient_email": "이메일 수령인",
    "createdDate": "만든 날짜",
    "dueDate": "마감일",
    "memo": "메모",
    "action": "행동",
    "email": "이메일",
    "phoneNumber": "전화 번호",
    "bankName": "銀行名",
    "recipientType": "받는 사람 유형",
    "fromAccountNumber": "계정 번호에서",
    "nameonCard": "카드의 이름",
    "zipCode": "우편 번호",
    "accountName": "口座名義",
    "routingNumber": "라우팅 번호",
    "accountType": "계정 유형",
    "address": "주소",
    "city": "도시",
    "country": "국가",
    "state": "주",
    "verificationType": "확인 유형",
    "debitAmount": "직불 금액",
    "firstCreditAmount": "첫 크레딧 금액",
    "secondCreditAmount": "두 번째 크레딧 금액",
    "nickName": "닉네임",
    "beneficiaryBankCode": "수취인 은행 코드",
    "addressLine1": "주소 1",
    "addressLine2": "주소 2",
    "paymentMethod": "지불 방법",
    "referenceID": "참조 ID",
    "aCHDetails": "ACH 세부 정보",
    "wireDetails": "와이어 세부 정보",
    "internationalTransferDetails": "국제 송금 세부 사항",
    "selectDate": "날짜 선택",
    "sender": "보내는 사람",
    "remarks": "비고",
    "buyorSell": "구매 또는 판매",
    "toAccountNumber": "계좌번호로",
    "paymentInstrument": "결제 수단",
    "fromaccount": "계좌로부터",
    "toCounterparty": "상대방에게",
    "purposeofPayment": "지불의 목적",
    "fXRate": "환율",
    "fXAmount": "외환 금액",
    "fXCurrency": "외환 통화",
    "toName": "이름을 지정하려면",
    "toAccount": "계정에",
    "nextTransactionDate": "다음 거래일",
    "aPICode": "API 코드",
    "publicKey": "공개 키",
    "privateKey": "개인 키",
    "optional": "선택 과목",
    "additionalInformation": "추가 정보",
    "createPayment": "결제 생성",
    "downloadPDF": "PDF 다운로드",
    "resend": "재전송",
    "approve": "승인하다",
    "decline": "취소",
    "addCard": "카드 추가",
    "addBankAccount": "은행 계좌 추가",
    "addNewRecipient": "새 수신자 추가",
    "synchronizeQuickBooks": "퀵북 동기화",
    "create": "만들다",
    "newUser": "새로운 사용자",
    "generate": "생성하다",
    "wITHDRAW": "철회하다",
    "confirm": "확인하다",
    "cancel": "취소",
    "close": "닫다",
    "sendResetInstructions": "재설정 지침 보내기",
    "logIn": "로그인",
    "resetPassword": "암호를 재설정",
    "setPassword": "암호를 설정하세요",
    "signUp": "가입하기",
    "forgotPassword": "비밀번호를 잊으 셨나요",
    "backToLogin": "로그인으로 돌아가기",
    "enterOtp": "인증 코드 입력",
    "resendCode": "새 코드 보내기",
    "selectPayment": "지불 유형 선택",
    "scheduleRecurringTransaction": "반복 트랜잭션 예약",
    "forgotPassText": "계정과 연결된 이메일을 입력하면 비밀번호 재설정 지침이 포함된 이메일을 보내드립니다.",
    "unableToCP": "결제를 생성할 수 없습니다.",
    "plsSelectPaymentTyp": "지불 유형을 선택하십시오",
    "plsSelectFromAcc": "계정에서 선택하세요.",
    "selectPaymentPayment": "지불 유형을 선택하십시오",
    "enterEmail": "이메일 주소를 입력하세요.",
    "emailValidation": "이메일 주소는 320자를 초과할 수 없습니다.",
    "enterPhone": "유효한 전화 번호를 입력하세요",
    "enterAccNum": "계좌번호를 입력해주세요",
    "AccNum": "계좌번호를 입력해주세요",
    "selectRecipientName": "받는 사람 이름을 선택하세요.",
    "enterAmounttoTransfer": "이체할 금액을 입력해주세요",
    "enterCurrency": "이체할 통화를 입력하세요.",
    "selectDirection": "방향을 선택하세요.",
    "selectPaymentDate": "결제일을 선택해주세요",
    "selectPaymentdate": "결제일을 선택해주세요",
    "selectServiceType": "서비스 유형을 선택하세요.",
    "selectFrequency": "빈도를 선택하세요.",
    "enterAmount": "금액을 입력하세요.",
    "selectTxnDate": "거래 날짜를 선택하세요.",
    "selectRecipientType": "받는 사람 유형을 선택하세요.",
    "enterEmailAddress": "이메일 주소를 입력하세요.",
    "validEmail": "유효한 이메일 주소를 입력하세요",
    "EmailValidation": "이메일 주소는 320자를 초과할 수 없습니다.",
    "selectFrmAcc": "계정에서 선택하세요.",
    "invoiceAlpha": "인보이스 번호는 영숫자여야 합니다.",
    "enterInvoiceNum": "인보이스 번호를 입력하세요.",
    "invoiceValidation": "인보이스 번호는 150자를 초과할 수 없습니다.",
    "amountToTransfer": "이체할 금액을 입력해주세요",
    "valueForMemo": "메모 값을 입력하십시오.",
    "memoValidation": "메모는 255자를 초과할 수 없습니다.",
    "selectPaymentType": "지불 유형을 선택하십시오",
    "enterName": "이름을 입력하세요.",
    "ValidName": "유효한 이름을 입력하십시오",
    "nameValidation": "이름은 3자 이상이어야 합니다.",
    "Name": "이름을 입력하세요.",
    "validname": "유효한 이름을 입력하십시오",
    "nameValid": "이름은 3자 이상이어야 합니다.",
    "enterZipCode": "우편번호를 입력하세요.",
    "validZipCode": "유효한 우편번호를 입력하세요.",
    "validzipcode": "우편번호는 5자리 미만일 수 없습니다.",
    "validAccName": "계정 이름을 입력하세요.",
    "enterValidAccName": "유효한 계정 이름을 입력하십시오",
    "maxAccName": "계정 이름은 20자리를 초과할 수 없습니다.",
    "minAccName": "계정 이름은 3자리 미만일 수 없습니다.",
    "accNum": "계좌번호를 입력해주세요.",
    "validAccNum": "유효한 계좌 번호를 입력하십시오",
    "maxAccNum": "계좌번호는 20자리를 넘을 수 없습니다.",
    "japanMaxAccNum": "계좌번호는 35자리를 넘을 수 없습니다.",
    "japanMaxBankName": "은행 이름은 35자리를 초과할 수 없습니다.",
    "japanMinSwiftCode": "Swift 코드는 최소 8자여야 합니다.",
    "japanMinAddress": "주소는 2자 이상이어야 합니다.",
    "japanMaxCity": "도시는 35자를 초과할 수 없습니다.",
    "minAccNum": "계좌번호는 4자리 이상이어야 합니다.",
    "routingNum": "라우팅 번호를 입력하십시오.",
    "validRoutingNum": "유효한 라우팅 번호를 입력하십시오",
    "minRoutingNum": "라우팅 번호는 9자리보다 작을 수 없습니다.",
    "ValidRoutingNum": "유효한 라우팅 번호를 입력하십시오.",
    "Acctype": "계정 유형을 선택하십시오.",
    "validAddress": "유효한 주소를 입력하십시오.",
    "maxAddress": "주소는 400자를 초과할 수 없습니다.",
    "minAddress": "주소는 5자 미만일 수 없습니다.",
    "City": "귀하의 도시를 입력하십시오.",
    "maxCity": "도시는 60자를 초과할 수 없습니다.",
    "countryName": "국가 이름을 선택하세요.",
    "stateName": "유효한 주를 입력하십시오",
    "validzipCode": "올바른 우편 번호를 입력 해주세요",
    "selectVerificationType": "확인 유형을 선택하십시오.",
    "debitAmnt": "출금금액을 입력해주세요.",
    "creditAmnt": "크레딧 금액을 입력하세요.",
    "CreditAmount": "크레딧 금액을 입력하세요.",
    "AccName": "계정 이름을 입력하세요.",
    "recipienttype": "받는 사람 유형을 선택하세요.",
    "accNumber": "계좌번호를 입력해주세요.",
    "validAccnum": "유효한 계좌 번호를 입력하십시오",
    "maxAccNumber": "계좌번호는 20자리를 넘을 수 없습니다.",
    "minAccNumber": "계좌번호는 4자리 이상이어야 합니다.",
    "beneficiaryBankcode": "수취인 은행 코드를 입력하세요.",
    "minRoutingNumber": "라우팅 번호는 9자리보다 작을 수 없습니다.",
    "acountNumber": "계좌번호를 입력해주세요.",
    "maxAccnum": "계좌번호는 20자리를 넘을 수 없습니다.",
    "minAccnum": "계좌번호는 4자리 이상이어야 합니다.",
    "routingnum": "라우팅 번호를 입력하십시오.",
    "maxRoutingnum": "라우팅 번호는 9자리보다 작을 수 없습니다.",
    "acctype": "계정 유형을 선택하십시오.",
    "accountNum": "계좌번호를 입력해주세요.",
    "validaccountNum": "유효한 계좌 번호를 입력하십시오",
    "maxAccountNum": "계좌번호는 20자리를 넘을 수 없습니다.",
    "minAccountNum": "계좌번호는 4자리 이상이어야 합니다.",
    "enterRoutingNum": "라우팅 번호를 입력하십시오.",
    "minRouting": "라우팅 번호는 9자리보다 작을 수 없습니다.",
    "enterAddressLine1": "주소 입력란 1을 입력하십시오.",
    "maxAddrss": "주소는 100자를 초과할 수 없습니다.",
    "minAddrss": "주소는 5자 미만일 수 없습니다.",
    "enterCity": "도시를 입력하십시오",
    "selectCountryName": "국가 이름을 선택하십시오.",
    "selectStateName": "주 이름을 선택하세요.",
    "validZipcode": "올바른 우편 번호를 입력 해주세요",
    "valdAccnum": "유효한 계좌 번호를 입력하십시오",
    "countryname": "국가 이름을 선택하십시오.",
    "statename": "유효한 주 이름을 입력하십시오",
    "selectpaymentMethod": "결제 방법을 선택하세요.",
    "validPhone": "유효한 전화 번호를 입력하세요",
    "inpFname": "이름을 입력하세요.",
    "inpLname": "성을 입력하세요.",
    "inpEmail": "이메일을 입력해주세요",
    "valiemail": "유효한 이메일을 입력하세요",
    "validFname": "유효한 이름을 입력하세요",
    "maxFname": "이름은 50자를 초과할 수 없습니다.",
    "minFname": "최소 3자가 필요합니다.",
    "validLname": "유효한 성을 입력하세요.",
    "maxLname": "성은 50자를 초과할 수 없습니다.",
    "minLname": "최소 3자가 필요합니다.",
    "phoneNum": "전화번호를 입력하세요.",
    "validPhoneNum": "유효한 전화 번호를 입력하세요",
    "maxPhone": "전화번호는 10자리를 넘을 수 없습니다.",
    "minPhone": "전화번호는 10자리여야 합니다.",
    "fromAcc": "계정에서 선택하세요.",
    "selectstartDate": "시작일을 선택하세요.",
    "newPsw": "새 비밀번호가 저장됨",
    "unablePsw": "비밀번호를 업데이트할 수 없습니다.",
    "inpOldPsw": "이전 비밀번호를 입력하세요.",
    "inpNewPsw": "새 비밀번호를 입력하세요",
    "maxPsw": "비밀번호는 8자 이상이어야 합니다.",
    "newPassword": "새 비밀번호를 확인하세요.",
    "result": "결과",
    "buyOrsell": "구매 또는 판매를 선택하십시오",
    "frmAccNum": "계좌번호에서 선택하세요.",
    "selectaccNum": "계좌번호를 선택해주세요",
    "paymentInst": "결제 수단을 선택하세요.",
    "instType": "악기 유형을 선택하세요.",
    "insufficientFunds": "자금 부족",
    "unablePayment": "결제를 생성할 수 없습니다.",
    "selectfundingType": "카드 및 계정을 선택하세요.",
    "amntTrans": "이체할 금액을 입력해주세요",
    "counterParty": "상대방을 선택해주세요.",
    "purposePayment": "결제 목적을 선택해주세요.",
    "toAcc": "계정으로 선택하세요",
    "validUrl": "유효한 URL을 입력하세요.",
    "all": "모두",
    "loading": "로드 중...",
    "transactions": "거래",
    "noAccountData": "계정 데이터 없음",
    "creditTransfer": "학점 이전",
    "noTransactionData": "거래 데이터 없음",
    "productCredit": "제품 크레딧",
    "refresh": "새로 고치다",
    "UWallets": "유월렛",
    "UWalletNumber": "유월렛 번호",
    "CreditID": "신용 ID",
    "InstrumentType": "악기 유형",
    "SelectCurrency": "통화 선택",
    "select": "고르다",
    "CardType": "카드 종류",
    "pleaseselecttheCardtype": "카드 종류를 선택해주세요",
    "CardNumber": "카드 번호",
    "ExpirationDate": "만료 날짜",
    "CVV": "CVV",
    "validCardNumber": "유효한 카드 번호를 입력하십시오",
    "failedAddCard": "카드를 추가하지 못했습니다.",
    "cardAddedSuccessfully": "카드가 성공적으로 추가되었습니다.",
    "validExpiration": "유효한 만료 날짜를 입력하십시오",
    "validCVV": "유효한 CVV 코드를 입력하십시오",
    "GoBack": "돌아가기",
    "Confirmation": "확인",
    "NoPaymentInstrumentData": "결제 수단을 찾을 수 없음",
    "deactivatePayment": "선택한 결제 수단을 비활성화하시겠습니까?",
    "accountVerified": "성공 !! 계정 정보가 성공적으로 확인되었습니다!!",
    "accountNotVerified": "죄송해요 !! 계정 세부정보를 확인할 수 없습니다.",
    "validAmount": "유효한 금액을 입력하세요.",
    "noConnectorFound": "결제 수단을 찾을 수 없음",
    "noCountryFound": "국가 목록을 찾을 수 없음",
    "wentWrongText": "문제가 발생했습니다.",
    "noStateFound": "상태 목록을 찾을 수 없음",
    "noteText": "참고: 시험 입금 프로세스를 사용한 은행 계좌 확인에는 영업일 기준 최대 5일이 소요됩니다.",
    "accountalreadyExists": "계좌번호가 이미 존재합니다.",
    "FeatureType": "기능 유형",
    "validFeatureType": "기능 유형을 선택하십시오.",
    "NoPaymentChannel": "결제 채널을 찾을 수 없음",
    "bankAddedsuccess": "은행 계좌가 성공적으로 추가되었습니다.",
    "bankAddedFailed": "은행 계좌를 추가하지 못했습니다.",
    "limitBreach": "제한 위반",
    "withdrawMethodSelect": "인출 방법 선택",
    "totalAmount": "총액",
    "decimalpointErr": "소수점 앞 최대 7자리 허용.",
    "termsandCondition": "이용 약관에 동의해야 합니다.",
    "agreeText": "동의합니다",
    "termsText": "이용 약관.",
    "minAmountTextAch": "최소 인출 금액은",
    "withdrawFeeText1": "인출 수수료",
    "withdrawFeeText2": "적용됩니다.",
    "maxAmountWithdrawTxt1": "최대 인출 금액은",
    "maxAmountWithdrawTxt2": "요청 당.",
    "withdrawSuccess": "출금 성공!",
    "createAnotherPay": "다른 결제 생성",
    "selectCurrency": "통화를 선택하세요.",
    "lowPayquickerBalance": "페이퀵커 잔액이 너무 낮아 결제할 수 없습니다.",
    "SelectPaymentMethod": "결제 수단 선택",
    "availablePayBalance": "사용 가능한 페이퀵커 잔액",
    "fundsLoadedSuccess": "자금이 성공적으로 로드되었습니다!",
    "invalidAccDetails": "잘못된 계정 정보",
    "insufficientAccBalance": "불충분한 계정 잔액",
    "invalidRecuDate": "잘못된 반복 날짜를 선택했습니다.",
    "invalidTONum": "유효하지 않은 계정 번호",
    "invalidTrans": "잘못된 거래",
    "counterPartyNotFound": "상대방을 찾을 수 없음",
    "ofacFailed": "OFAC 확인 실패",
    "interSORFail": "SOR 간 거래 불가",
    "invalidRoutingNum": "유효하지 않은 라우팅 번호",
    "requestedServiceNotAvail": "현재 요청한 서비스를 사용할 수 없습니다.",
    "limitExceedGlobal": "전역 한도 초과",
    "clientLimitExceed": "클라이언트 거래 한도 초과",
    "dailyLimitExceed": "일일 거래 한도 초과",
    "invalidRecdetails": "잘못된 수신자 세부정보",
    "unabletoQuote": "견적을 받을 수 없습니다.",
    "enterRecipntPhone": "받는 사람 전화번호 입력",
    "enterAccNumber": "수취인 계좌번호 입력",
    "accountNotMatch": "계좌번호가 일치하지 않음",
    "recipientAccount": "받는 사람 계정",
    "convertedAmount": "환산금액",
    "paymentSuccess": "결제가 성공적으로 생성되었습니다!",
    "orderNumber": "주문 번호",
    "showing": "전시",
    "of": "의",
    "refNumber": "참조 번호",
    "details": "세부",
    "NoTransactionsFound": "거래를 찾을 수 없음",
    "conntedTOQB": "퀵북에 성공적으로 연결됨",
    "QuoteConvertedAmount": "총 견적 전환 금액",
    "QBConnectFailed": "퀵북에 연결하지 못했습니다.",
    "conenctingToQB": "퀵북에 연결 중입니다. 잠시만 기다려 주십시오...",
    "synchronizeFailed": "퀵북 동기화 실패",
    "synchronizeSuccess": "성공적으로 동기화된 퀵북",
    "syncQBText": "퀵북과 동기화 상태 유지",
    "accountConnectedToQB": "퀵북에 이미 연결된 계정",
    "Password": "비밀번호",
    "profileChangesSaved": "프로필 변경 사항이 저장되었습니다.",
    "Timezone": "시간대",
    "Locale": "장소",
    "passwordUpdateSuccess": "비밀번호 변경 사항이 성공적으로 저장되었습니다.",
    "passwordReqText": "암호는 지정된 요구 사항을 따라야 합니다.",
    "passwordNotMatch": "입력한 두 개의 비밀번호가 일치하지 않습니다",
    "newUserSuccess": "새 사용자가 성공적으로 생성되었습니다.",
    "addNewUser": "새 사용자 추가",
    "ssoReq": "SSO 필요",
    "logoutTxt": "성공적으로 로그아웃되었습니다",
    "updatePaymentSuccess": "성공! 결제 수단을 성공적으로 업데이트했습니다.",
    "updatePaymentFailed": "결제 수단을 업데이트하지 못했습니다.",
    "noDataFoundFound": "데이터가 없습니다",
    "submit": "제출하다",
    "completed": "완전한",
    "failed": "실패한",
    "pending": "보류 중",
    "sent": "전송된",
    "SessionExpired": "세션이 만료됨",
    "Uwallet": "유월렛",
    "UWalletfunding": "유월렛 펀딩",
    "debit": "차변",
    "credit": "신용 거래",
    "CARD": "카드",
    "BANK": "은행",
    "active": "활동적인",
    "ccintl": "신용카드 인터내셔널",
    "amex_dis": "아멕스/디스커버",
    "amex_card_text": "아멕스 카드 추가",
    "nodata": "데이터 없음",
    "note": "메모",
    "load_fund_via_card": "카드로 자금 충전",
    "load_fund_via_ach": "ACH를 통한 자금 충전",
    "load_fund_via_connector": "커넥터를 통한 자금 로드",
    "p2m_via_connector": "커넥터를 통한 P2M",
    "creditAdjustment": "신용 조정",
    "debitAdjustment": "차변 조정",
    "startDateText": "시작일",
    "endDateText": "종료 날짜",
    "payIn": "지불하다",
    "payOut": "지불금",
    "checking": "확인 중",
    "saving": "절약",
    "verify": "확인하다",
    "reset": "초기화",
    "today": "오늘",
    "a2a_reversal": "A2A 반전",
    "credit_point": "크레딧 포인트",
    "commission_payout_via_ach": "ACH를 통한 커미션 지급",
    "commission_payout_via_uWallet": "UWallet을 통한 커미션 지급",
    "commission_payout_via_payquicker": "페이퀵커를 통한 커미션 지급",
    "withdraw_via_ach": "ACH를 통해 자금 인출",
    "withdraw_via_payquicker": "페이퀵커를 통해 자금 인출",
    "credit_reversal": "신용 취소",
    "load_fund_via_card_reversal": "카드 취소를 통한 자금 충전",
    "uwallet_funding_reversal": "유월렛 펀딩 취소",
    "processing": "처리",
    "declined": "거부됨",
    "onHold": "보류 중",
    "scheduled": "예정",
    "cancelled": "취소 된",
    "paymentCancelled": "결제가 취소되었습니다.",
    "beneficiaryName": "수취인 이름",
    "b_b_code": "은행 코드 및 지점 코드",
    "validBankCode": "유효한 코드를 입력하세요",
    "minBankCode": "코드는 7자리 미만일 수 없습니다.",
    "load_fund_wallet": "자금 지갑 로드",
    "ach_transfer": "ACH 전송",
    "mater_visa": "마스터카드/비자",
    "go_to_transaction": "거래로 이동",
    "p2m_reversal": "P2M 반전",
    "deposit_account_list": "예금 계좌 목록",
    "load_fund_via_ach_reversal": "ACH 반전을 통한 자금 로드",
    "load_fund_via_connector_reversal": "커넥터 반전을 통한 자금 로드",
    "KYC_Failed": "KYC 인증 실패",
    "updateKYCText": "KYC 세부 정보를 업데이트하시겠습니까?",
    "updateWithdrawKYCText": "자금을 인출하기 전에 본인 확인을 완료해야 합니다.",
    "userType": "사용자 유형",
    "usertypeErr": "사용자 유형을 선택하십시오.",
    "recidencyNumberTxt": "주민등록번호",
    "validResNum": "주민등록번호 필수",
    "validresidencyNum": "유효한 주민번호를 입력하세요.",
    "flexText": "PayQuicker Flex",
    "flexTextVietnam": "Thanh toán linh hoạt",
    "withdrawalConfig": "출금 설정",
    "withdrawalConfiguration": "출금 구성",
    "addConfig": "구성 추가",
    "addFreequencyConfig": "주파수 구성 추가/편집",
    "ReceivingAccount": "수신 계정",
    "deactivateConfig": "선택한 구성을 비활성화하시겠습니까?",
    "updateConfigSuccess": "성공! 구성을 성공적으로 업데이트했습니다.",
    "updateConfigFailed": "구성을 업데이트하지 못했습니다.",
    "add_card_text": "신용카드 추가",
    "UWalletTransfer": "UWallet 전송",
    "daily": '일일',
    "weekly": "주간",
    "monthly": "월간 간행물",
    "biweekly": "격주 간행물",
    "immediate": "즉각적인",
    "percentage": "백분율",
    "percentError": "유효한 백분율을 입력하십시오",
    "toDistributor": "대리점에",
    "distributorId": "대리점 ID를 입력하세요.",
    "invalidDistributor": "유효한 대리점 ID를 입력하십시오",
    "distributorNotFound": "배포자를 찾을 수 없음",
    "distributorKYCError": "수신자 배포자가 확인되지 않음",
    "decimalNotPermit": "소수점 이하 자릿수는 허용되지 않습니다.",
    "paybyCard": "카드 결제",
    "validIDNum": "유효한 숫자를 입력하십시오",
    "swiftCode": "스위프트 코드",
    "validBankName": "유효한 은행 이름을 입력하세요.",
    "JAPANPAYOUT": "은행",
    "idNumber": "ID 번호",
    "commissionHistory": "수수료 내역",
    "CITCON WITHDRAWAL": "은행 출금",
    "validCityName": "올바른 도시 이름을 입력하세요.",
    "pendingApproval": "승인 보류 중",
    "purposeCode": "지불 목적",
    "plsSeletpurposeCode": "결제 목적을 선택해 주세요",
    "QualifyingCredit": "적격 학점",
    "tooltipAccountName": "이름과 성을 포함한 전체 이름을 입력하세요(개인인 경우). 예: John Smith 또는 전체 법적 회사 이름(회사인 경우). 예: ABC Limited",
    "tooltipAccountNumber": "은행계좌번호를 입력하세요",
    "tooltipBankCode": "은행코드를 입력하세요",
    "tooltipBranchCode": "지점코드를 입력하세요",
    "tooltipSwiftBic": "은행의 SWIFT BIC(은행 식별 코드)를 8자 또는 11자 길이로 입력하세요. SWIFT BIC가 8자에 불과한 경우 XXX를 추가하여 11자를 채우지 마세요.",
    "tooltipAddress": "거주지(개인인 경우) 또는 등록된(회사인 경우) 집 번호/이름 및 거리 이름을 입력하세요(예: 1 Main Street)",
    "tooltipCity": "거주지(개인인 경우) 또는 등록된 주소(회사인 경우)의 도시나 마을을 입력하세요(예: 런던)",
    "tooltipZipcode": "거주지(개인인 경우) 또는 등록된 주소(회사인 경우)의 우편번호를 입력하세요.",
    "tooltipCountry": "거주지(개인인 경우) 또는 등록된 주소(회사인 경우)를 선택하세요.",
    "tooltipDOB": "생년월일을 선택해주세요. (개인인 경우)",
    "tooltipBankName": "은행명을 입력해주세요.",
    "bankCode": "은행 코드",
    "branchCode": "지점 코드",
    "dob": "생일",
    "selct_currency_deposit": "화폐",
    "pc_from_text": "에서",
    "pc_to_text": "에게",
    "pc_amount_text": "양",
    "CNY PAYOUT": "Bank (WP)",
    "accountHolderaddress": "계좌 소유자의 주소",
    "accountHolderName": "계좌 소유자 이름",
    "branchName": "支店名",
    "continue": "계속하다",
    "validBranchName": "유효한 지점 이름을 입력하세요.",
    "SOLU": "은행 출금",
    "cardUpdatedSuccessfully": "카드가 업데이트되었습니다.",
    "reason": "이유",
    "failedUpdateCard": "카드를 업데이트하지 못했습니다.",
    "requiredError": "이 필드는 필수입니다",
    "kycNotVerified": "KYC가 확인되지 않았습니다.",
    "VND PAYOUT": "철회하다 WP",
    "phoneNumberAliWP": "86 XXX XXXX XXXX",
    "phoneTooltip": "수혜자의 전화번호를 입력해 주세요 (예: 86 XXX XXXX XXXX)",
    "emailTooltip": "수혜자의 이메일 주소를 입력해 주세요",
    "ALIPAY PAYOUT WP": "Alipay",

    "enterValidAccNameWithLimit": "Enter Valid Payee name with minimum 2 and maximum 70 characters",
    "enterValidAccNumWithLimit": "Enter Valid account number with minimum 4 and maximum 17 characters",
    "enterValidRoutingNumWithLimit": "Enter Valid routing number",
    "enterValidAddressWithLimit": "Enter Valid Address with minimum 2 and maximum 70 characters",
    "enterValidCityWithLimit": "Enter Valid City with minimum 2 and maximum 35 characters",
    "enterValidZipcodeWithLimit": "Enter Valid Zip code with minimum 2 and maximum 10 characters",
    "enterCitconValidAccNumWithLimit": "Enter Valid account number with minimum 4 and maximum 25 characters",

    "enterValidAccNameWithChinese": "Enter valid name in Chinese Characters",
    "enterValidBankNameWithChinese": "Enter valid Bank name in Chinese Characters",
    "enterValidBranchNameWithChinese": "Enter valid Branch name in Chinese Characters",
    "enterValidSoluAccNum": "Enter Valid numeric account number",
    "enterValidSoluAccNumWith20Limit": "Enter Valid numeric account number maximum 20 characters.",
    "enterValidSoluAccNumWith17Limit": "Enter Valid numeric account number maximum 17 characters.",
    "enterValidSoluPhoneNumWithLimit": "Enter Valid numeric phone number maximum 20 characters.",
    "enterValidSoluIDNumWithLimit": "Enter Valid alphanumeric ID number maximum 100 characters.",

    "enterValidAlipayPayeeNameWithLimit": "Enter Valid Payee name with minimum 2 and maximum 35 characters",
    "enterValidAlipayPhoneNumWithLimit": "Enter Valid numeric phone number with minimum = 5 maximum 34 characters.",
    "enterValidAlipayEmailWithLimit": "Enter Valid Email address  with minimum = 6 maximum 100 characters.",

    "enterValidThanhAccNameWithChinese": "Enter Valid  account name with minimum 1 and maximum 140 characters.",
    "enterValidThanhAccNumWithLimit": "Enter Valid  account number  with minimum 1 and maximum 30 characters.",
    "enterValidThanhSwiftCodeWithLimit": "Enter Valid swift code with minimum 8 and maximum 11 characters.",
    "enterValidThanhAddressWithLimit": "Enter Valid  address  with minimum 2 and maximum 35 characters.",

    "enterValidBeneficiaryNameWithLimit": "Enter valid name with maximum 20 characters.",
    "enterValidTWDAccNumWithLimit": "Enter valid account number with maximum 20 characters.",
    "enterValidTWDBranchCodeWithLimit": "Enter valid branch code with maximum 7 characters.",

    "enterValidMYRAccNameWithLimit": "Enter valid name with minimum = 2 and maximum 50 characters.",
    "enterValidMYRAccNumWithLimit": "Enter valid numeric account number with maximum 16 characters.",

    "enterValidTHBAccNameWithLimit": "Enter valid name with maximum 35 characters.",
    "enterValidTHBAccNumWithLimit": "Enter valid numeric account number  with  maximum 12 characters.",
    "enterValidTHBSwiftCodeWithLimit": "Enter valid swift code with maximum 11 characters.",
    "enterValidTHBAddressWithLimit": "Enter valid Address with minimum = 5 and maximum 35 characters.",
    "enterValidTHBCityWithLimit": "Enter valid city with maximum 60 characters.",
    "enterValidTHBZipcodeWithLimit": "Enter valid zip code with minimum = 5 and maximum 10 characters.",

    "enterValidGBPPayeeNameWithLimit": "Enter valid name with Minimum 3 and maximum 50 characters.",
    "enterValidGBPIbanWithLimit": "Enter valid Iban with maximum 34 characters.",
    "enterValidGBPBankNameWithLimit": "Enter valid Bank name with Minimum = 1 and maximum 50 characters.",

    "enterValidEURAccNameWithLimit": "Enter valid name with Minimum 1 and maximum 50 characters.",
    "enterValidEURAccNumWithLimit": "Enter valid numeric account number  with  Minimum 1 and maximum 35 characters.",
    "enterValidEURBankNameWithLimit": "Enter valid Bank name with Minimum = 2 and maximum 10 characters.",

    "enterValidJPYBankNameWithLimit": "Enter valid bank name with  maximum 35 characters.",
    "acceptTermsandconditions": "I followed the guide and set up my Alipay account to receive funds",
    "failedDuplicateCard": "Card addition failed as card already exist.",
    "updatedDate": "Updated Date",
    "noBankFound": "No Bank Found",
    "enterValidPhoneNumberWithLimit": "Enter Valid PhoneNumber with minimum 3 and maximum 35 characters",
    "branchNumber": "支店番号",
    "bankNumber": "銀行番号",
    "validBankNumber":  "Enter valid Bank number with maximum 4 characters.",
    "validBankNameWithLimit": "Enter valid Bank name with maximum 15 characters.",
    "validBranchNumber": "Enter valid Branch number with maximum 3 characters.",
    "validBranchNameWithLimit": "Enter valid Branch name with maximum 15 characters.",
    "selectAccountType": "Please select account type",
    "enterValidJPYAccNumWithLimit": "Enter valid numeric account number  with  Minimum 1 and maximum 7 characters.",
    "enterIntegerAmount": "Please enter a valid amount as an integer",
    "enterValidZenAccNameWithLimit": "Enter valid name with maximum 30 characters.",
    "zenginAccountNameHelperText": "Please enter the account holder name exactly as registered with the bank, using half-width katakana.",
    "weeklyProcessingNoticeText": "Weekly Processing Notice: Withdrawals using this account type are processed via a Zengin file generated once per week. Your transaction will remain pending until the next weekly processing. Funds typically arrive 1-3 business days after the file is generated.",
    "paybyJkoPay": "Pay by JKO Pay",
    "paybyAlipayHK": "Pay by Alipay HK",
    "paybyAlipay": "Pay by Alipay",
    "paybyUnionPay": "Pay by Union Pay",
    "addPaybyCard": "Add & Pay by Card",
    "address2": "Address2",
    "firstNameLocal": "Local First Name",
    "lastNameLocal": "Local Last Name",
    "paymentChannel": "Payment Channel",
    "paymentChannelErr": "Please select an Payment Channel.",
    "relationShip": "RelationShip",
    "validRelationShip": "Please enter valid relationship value",
    "abaRoutingCode": " 라우팅 번호",
    "payee": "수취인",
    "payeeTitle": "칭호",
    "validPayeeTitle": "칭호를 선택해 주세요.",
    "houseName": "집 번호/이름 및 거리 이름",
    "payeeTooltip": "귀하의 전체 이름 또는",
    "promptPay": "PromptPay",
    "bankTransferThailand": "Bank Transfer (Thailand)",
    "paymentInstrumentInUseAutoShipments": "활성 자동배송에서 사용 중인 카드이므로 해당 uWallet 계정에서 이 저장된 카드를 비활성화/삭제할 수 없습니다. 먼저 활성 자동배송에 연결된 결제 수단을 업데이트한 후 다시 시도해 주십시오. 해당 자동배송 ID는 다음과 같습니다 ",
    "paymentInstrumentInUseAutoShipmentsTwo": "이 카드에 연결된 자동배송은 다음과 같습니다 ",
    "newTextTo": "얼마를 송금하시겠습니까",
    "transferAmountDebit": "에서 인출된 총액",
    "transferAmountIn": "에 입금된 총액 ",

    "EditBillingAddress": "청구 주소 편집",
    "BillingAddress": "청구 주소",
    "AddBillingAddress": "청구 주소 추가",
    "billingAddress1": "주소 1행",
    "billingAddress2": "주소 2행",
    "billingAddress3": "주소 3행",
    "billingCity": "청구 도시",
    "billingState": "청구 주/도",
    "billingZipcode": "청구 우편번호",
    "billingCountry": "청구 국가",
    "validBillingAddress": "유효한 청구 주소를 입력하세요",
    "validBillingCity": "유효한 청구 도시를 입력하세요",
    "validBillingState": "유효한 청구 주/도를 입력하세요",
    "validBillingZipcode": "유효한 청구 우편번호를 입력하세요",
    "validBillingCountry": "청구 국가를 선택하세요",
    "savedBillingAddress": "저장된 청구 주소",
    "billingInforText": "저장된 주소 목록에서 청구 주소를 선택하여 카드에 사용할 수 있습니다.",
    "autoshipManagement": "Autoship Management",
    "autoshipReference": "Autoship Reference",
    "deactivateAutoship": "Do you want to deactivate selected Autoship?",
    "updateAutoshipSuccess": "Success! Autoship updated successfully",
    "updateAutoshipFailed": "Failed to update Autoship",
    "autoshipError": "Please select a payment instrument/connector for proceeding with the payment for subscriptions",
    "autoshipExternalId": "External ID",
    "paybyBankOrOnSite": "Pay by Bank or On-Site",
    "uwalletAmountCheckText": "Please enter valid UWallet amount",
    "uwalletFundAmountCheckText": "Please enter valid UWallet Funding amount",
    "paymentMethodErrorText": "Please select any payment method",
    "maintainanceNotice": "UWallet 업데이트되었습니다. 계정에 하나의 기본 통화를 사용하는 방식으로 지갑 업그레이드가 완료되었습니다.",
    "maintainanceNotice_1": "이제 통화별로 분리된 잔액 대신, 기본 지갑 통화 기준의 단일 잔액이 표시됩니다.",
    "maintainanceNotice_2": "이전에 보유하고 계셨던 다른 통화의 잔액은 정의된 환율을 기준으로 기본 지갑 통화로 자동 환전되었습니다.",
    "maintainanceNotice_3": "자금, 거래 내역, 지급 일정은 모두 그대로 유지되며 이전과 동일하게 정상 작동합니다.",
    "contactSupport": "표시된 내용에 이상이 있거나 문의 사항이 있으신 경우, 고객 지원팀에 연락하시고 “지갑 업데이트”라고 말씀해 주세요.",
    "txnAmount": "Transaction Amount",
    "cardHolderName": "Card Holder Name",
    "noBranchNumberFound": "No Branch Number Found",
    "payoutMethod": "Payout Method",
    "selectPayoutMethod": "Please select Payout Method",
    "accountDuplicateError": "The account is detected as a duplicate",
    "kycTextForBusiness": "You already have a verification in progress. Please wait for it to complete before submitting another.",
     "inpFnameChinese": "중국어로 된 유효한 이름을 입력해 주세요.",
    "inpLnameChinese": "중국어로 된 유효한 성을 입력해 주세요.",
    "inpFnameEnglish": "영어로 된 유효한 이름을 입력해 주세요.",
    "inpLnameEnglish": "영어로 된 유효한 성을 입력해 주세요.",
    "unionPayCard": "유니온페이 카드",
    "verified": "확인됨",
    "p2pLookupError": "이 Distributor ID를 확인할 수 없습니다. ID를 확인한 후 다시 시도해 주세요.",
    "p2pEnterReceiverInformation": "수취인 정보 입력",
    "p2pDistributorId": "Distributor ID",
    "p2pDistributorTooltip": "대상 Distributor 번호 앞에는 “R”이 필요합니다.",
    "p2pEnterDistributorId": "Distributor ID 입력",
    "p2pReceiverNameAsPerRecords": "수취인 이름 (당사 기록 기준)",
    "p2pVerifyingReceiver": "수취인 확인 중...",
    "p2pVerifyAfterDistributorId": "유효한 Distributor ID를 입력하면 수취인 확인 결과가 표시됩니다.",
    "p2pReceiverNameLabel": "수취인 이름",
    "p2pEnterReceiverName": "수취인 이름 입력",
    "p2pVerifyReceiverDistributorFirst": "먼저 수취인의 Distributor ID를 확인해 주세요.",
    "p2pReceiverNameMismatch": "수취인 이름이 기록과 일치하지 않습니다.",
    "p2pReceiverNameMatch": "수취인 이름이 기록과 일치합니다.",
    "p2pEnterReceiverNameAsPerRecords": "기록된 수취인 이름 입력",
    "p2pReceiverNameHelpText": "위 이름이 송금하려는 실제 수취인과 일치하는지 확인해 주세요.",
    "p2pConfirmDistributorIdStep": "Distributor ID 확인",
    "p2pReenterDistributorIdHelp": "Distributor ID를 다시 입력해 주세요. (복사 및 붙여넣기 비활성화)",
    "p2pCopyPasteDisabled": "복사 및 붙여넣기가 비활성화되어 있습니다.",
    "p2pConfirmDistributorIdLabel": "Distributor ID 확인",
    "p2pReenterDistributorId": "Distributor ID 다시 입력",
    "p2pDistributorIdsMustMatch": "Distributor ID가 일치하지 않습니다. 확인 후 다시 시도해 주세요.",
    "p2pEnterTransferDetails": "송금 정보 입력",
    "p2pWhyTheseSteps": "왜 이런 단계가 필요한가요?",
    "p2pWhyTheseStepsLine1": "이름 확인을 통해 올바른 수취인에게 송금하는지 확인할 수 있습니다.",
    "p2pWhyTheseStepsLine2": "Distributor ID를 다시 입력하면 실수와 오송금을 줄일 수 있습니다.",
    "p2pWhyTheseStepsLine3": "고객님의 보안은 가장 중요합니다.",
    "p2pPrivacyNote": "개인정보 보호를 위해 수취인의 중간 이름은 숨겨집니다.",
    "p2pMonthlyLimitNote": "P2P 월간 한도는",
    "p2pMaxMonthlyLimitNote": "최대 월간 한도는",
    "p2pFeeNote": "P2P 수수료",
    "p2pFeeNoteSuffix": "가 적용됩니다."
}
